import * as React from 'react';
import Item from './Item';

interface SubMenuProps {
  children?: React.ReactNode[] | React.ReactNode;
}

const SubMenu = ({ children }: SubMenuProps) => {
  return <ul className="br-menu-sub">{children}</ul>;
};

SubMenu.Item = Item;

export default SubMenu;
